<template lang="">
    <v-card>
        <s-crud
            :config="config"
            title="Check List"
            :filter="filter"
            search-input
            add
            edit
            remove
            @save="save($event)"
        >
            <template v-slot="props">
                <v-container>
                    <v-row >
                        <v-col cols="6">
                            <s-text label="Nombre de Lista" v-model="props.item.CktName"></s-text>
                        </v-col>
                    </v-row>
                </v-container>
            </template>

            <template v-slot:CktList="{ row }">
                <v-btn x-small elevation="0" color="primary" @click="CktListModal(row)">
                    <v-icon small>mdi-format-list-numbered</v-icon>
                </v-btn>
            </template>
            <template v-slot:CktShare="{ row }">
                <v-btn x-small elevation="0" color="success" @click="CktShareModal(row)" v-if="row.UsrCreateID == filter.UsrID">
                    <v-icon small>mdi-account-multiple</v-icon>
                </v-btn>
                <v-chip x-small v-else label color="info"><v-icon left small>mdi-share-variant</v-icon>Compartido por {{row.NtpFullName}}</v-chip>
            </template>
        </s-crud>

        <v-dialog persistent v-if="openDialog" v-model="openDialog" max-width="700px">
            <OptionsCheck :item="dataSeletected" @close="close"></OptionsCheck>
        </v-dialog>

        <v-dialog persistent v-if="openDialogUser" v-model="openDialogUser" max-width="600px">
            <UserAssigned :item="dataSeletected" @closeUser="closeUser"></UserAssigned>
        </v-dialog>

    </v-card>
</template>

<script>
import _sCheckListService from '@/services/Utility/CheckListService';
import OptionsCheck from './OptionsCheck.vue';
import UserAssigned from './UserAssigned.vue';
export default {
    components: {
        OptionsCheck,
        UserAssigned
    },
    data() {
        return {
            filter: {},
            openDialog: false,
            openDialogUser: false,
            dataSeletected : {},
            config: {
                model: {
                    CktID: "ID",
                    SecCreate: "datetime"
                },
                service: _sCheckListService,
                headers: [
                    { text: "ID", value: "CktID" },
                    { text: "Lista", value: "CktList", width: 100 },
                    { text: "Nombre", value: "CktName" },
                    { text: "Compartir", value: "CktShare", width: 200 },
                    { text: "F. Creación", value: "SecCreate" },
                ]
            },
        }
    },
    methods: {
        save (item) {
            if (!item.CktName) {
                this.$fun.alert("Ingrese el nombre de la lista", "warning");
                return;
            }
            item.NtpID = this.$fun.getUserInfo().NtpID;
            item.PrsID = this.$fun.getUserInfo().PrsID;
            item.UsrID = this.$fun.getUserID();
            item.UsrCreateID = this.$fun.getUserID();
            item.UsrUpdateID = this.$fun.getUserID();

            item.save();
        },
        CktListModal(row) {
            this.dataSeletected = row;
            this.openDialog = true;
        },
        CktShareModal(row) {
            this.dataSeletected = row;
            this.openDialogUser = true;
        },
        close() {
            this.openDialog = false;
        },
        closeUser() {
            this.openDialogUser = false;
        }
    },
    mounted() {
        this.filter.UsrID = this.$fun.getUserID();
        //console.log(this.$fun.getUserInfo().NtpID);
    }
}

</script>